import { render, staticRenderFns } from "./DuplicateReport.vue?vue&type=template&id=00a8758d&scoped=true&"
import script from "./DuplicateReport.vue?vue&type=script&lang=js&"
export * from "./DuplicateReport.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateReport.vue?vue&type=style&index=0&id=00a8758d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a8758d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VDivider,VFlex,VIcon,VLayout})
